import "./src/styles/global.css"

// Netlify Identity — redirect back to /admin/ after login
export const onRouteUpdate = () => {
  if (
    typeof window !== "undefined" &&
    (window as Window & { netlifyIdentity?: { on: (event: string, cb: () => void) => void } }).netlifyIdentity
  ) {
    const ni = (window as Window & { netlifyIdentity?: { on: (event: string, cb: () => void) => void } }).netlifyIdentity!
    ni.on("init", (user: unknown) => {
      if (!user) {
        ni.on("login", () => {
          document.location.href = "/admin/"
        })
      }
    })
  }
}
